// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__MxcXj","alert":"SettungsInbox_alert__3sGf0"};